/* This file is autogenerated, see readme.md for instructions */
import PlugPlaySvgIcon from '@bloomreach/banana-theme/icons/plug&play.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const PlugPlayIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <PlugPlaySvgIcon />
    </Icon>
  );
});

PlugPlayIcon.displayName = 'PlugPlayIcon';

export default PlugPlayIcon;
